<ng-container *ngIf="(language.lang()|async) as lang">
  <div class="box-note" *ngIf="lang.LangID != 'EN'">
    <div style="height: 36px; width: 36px; align-self: center;">
  <svg xmlns="http://www.w3.sport/2000/svg" height="36" viewBox="0 0 36 36" width="36"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
</div>
  <p class="translated" >{{'rulebook.lang_advise' | transloco}}</p>
</div>
</ng-container>
<header [ngClass]="{'header': true, 'header--home': type == 'home', 'header--standard': type != 'home' }">
  <div class="header__actions">
    <a routerLink="/rulebook" class="header__back" *ngIf="type != 'home'">{{'rulebook.back' | transloco}}</a>
    <app-search-redirect></app-search-redirect>
    <app-filter-lang></app-filter-lang>
  </div>
<header>
